import { Button } from 'ui-components';
import DatatransErrorModal from './DatatransErrorModal';
import Lightbox from 'react-datatrans-light-box';
import { env } from 'navigation';

type Props = {
  loading?: boolean;
  datatransId?: string;
  onCancel: () => void;
  transactionError?: string;
  onErrorClose: () => void;
} & React.ComponentProps<typeof Button>;

export function CheckoutButton({
  datatransId,
  onCancel,
  loading = false,
  transactionError = '',
  onErrorClose,
  ...props
}: Props): JSX.Element {
  return (
    <>
      <Button type="button" data-mode={env} loading={loading} {...props}>
        Jetzt buchen
      </Button>

      {datatransId && (
        <Lightbox
          transactionId={datatransId}
          production={env === 'production'}
          onCancelled={onCancel}
        />
      )}

      <DatatransErrorModal
        open={!!transactionError}
        error={transactionError}
        onClose={onErrorClose}
      />
    </>
  );
}
